import * as React from 'react';

import { enumLoadStatus } from '@rematter/frontend-lib-api-client';

import { SalesDetailLayout } from '../_layouts/SalesDetailLayout';
import { LoadShippingForm } from '../_shared/LoadShippingForm';

import { LoadFormFooterActions } from './LoadFormFooterActions';

import { LoadFormState, LoadRecord } from '~/modules/trade/types/load';

type Props = {
  load?: LoadRecord | null;
  onDiscard?: () => void;
  onSaveUpdates?: (
    tab?: 'materials' | 'load-info',
    data?: LoadFormState,
  ) => void;
  isSaving?: boolean;
};

export const LoadTabShipmentInfo: React.FC<Props> = ({
  load,
  onDiscard,
  onSaveUpdates,
  isSaving = false,
}) => {
  const isDisabled =
    load?.status === enumLoadStatus.Voided ||
    load?.status === enumLoadStatus.Reconciled ||
    load?.status === enumLoadStatus.Received;

  return (
    <SalesDetailLayout
      className="@LoadTabShipmentInfo h-auto"
      footer={
        !isDisabled && (
          <LoadFormFooterActions
            tab="load-info"
            onSaveUpdates={onSaveUpdates}
            onDiscard={onDiscard}
            isSaving={isSaving}
          />
        )
      }
    >
      <LoadShippingForm
        load={load}
        disabled={load?.status === enumLoadStatus.Voided}
        showBorder={false}
        hideNotes
        showTitle
      />
    </SalesDetailLayout>
  );
};
